import { helper } from '@ember/component/helper';
import { isEmpty } from '@ember/utils';

export function startWith(
  [str, prefix]: [str: string | undefined, prefix: string | undefined] /*, hash*/
) {
  return (
    !isEmpty(str) &&
    !isEmpty(prefix) &&
    `${str}`.toLowerCase().startsWith(`${prefix}`.toLowerCase())
  );
}

const startWithHelper = helper(startWith);
export default startWithHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    startWith: typeof startWithHelper;
  }
}
